import React, { useState } from 'react';
import { Button, useTranslate } from 'react-admin';
import { UploadFile } from '@mui/icons-material';
import { CsvImportDialog } from './CsvImportDialog';

export const ImportCsvButton: React.FC = () => {
    const translate = useTranslate();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                label={translate('resources.vehicle-models.actions.importCsv', {
                    _: 'Import from CSV',
                })}
                startIcon={<UploadFile />}
            />
            <CsvImportDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
